export const hasPermission = (rolePermissions, module, permissionKey) => {
  if (!rolePermissions) return false;

  // Super Admin or full access role
  if (rolePermissions.hasFullPermission) return true;

  const moduleData = rolePermissions.permissions?.find(
    (item) => item.module === module
  );

  if (!moduleData) return false;

  return moduleData?.permissions?.includes(permissionKey);
};
